document.addEventListener('DOMContentLoaded', () => {
  const customOptions = document.querySelector('.custom-options');
  if (!customOptions) return; // Exit if not on the target product

  // Elements
  const imageRadios = document.querySelectorAll('input[name="image"]');
  const step2 = document.querySelector('.step-2');
  const step3 = document.querySelector('.step-3');
  const optionInputs = document.querySelectorAll('.option-list input[type="number"]');
  const threadColor = document.getElementById('thread-color');
  const priceDisplay = document.getElementById('dynamic-price');

  // Option prices (adjust as needed)
  const optionUnitPrices = {
    'option-1': 2, 'option-2': 2, 'option-3': 2, 'option-4': 2,
    'option-5': 2, 'option-6': 2, 'option-7': 2, 'option-8': 2,
    'option-9': 2, 'option-10': 2, 'option-11': 2, 'option-12': 2,
    'option-13': 2, 'option-14': 2
  };

  let selectedImagePrice = 0;
  let optionQuantities = Array(14).fill(0);
  let threadColorPrice = 0;

  // Update price
  function updatePrice() {
    let totalPrice = selectedImagePrice;
    optionQuantities.forEach((qty, i) => {
      totalPrice += qty * optionUnitPrices[`option-${i + 1}`];
    });
    totalPrice += threadColorPrice;
    priceDisplay.textContent = `$${totalPrice.toFixed(2)}`;
  }

  // Enable/disable steps
  function updateSteps() {
    const imageSelected = Array.from(imageRadios).some(radio => radio.checked);
    step2.style.display = imageSelected ? 'block' : 'none';
    step3.style.display = imageSelected ? 'block' : 'none';
    optionInputs.forEach(input => {
      input.disabled = !imageSelected;
      input.closest('.option-item').querySelector('.decrement').disabled = !imageSelected;
      input.closest('.option-item').querySelector('.increment').disabled = !imageSelected;
    });
    threadColor.disabled = !imageSelected;
  }

  // Image selection
  imageRadios.forEach(radio => {
    radio.addEventListener('change', () => {
      selectedImagePrice = parseFloat(radio.dataset.price) || 0;
      updateSteps();
      updatePrice();
    });
  });

  // Increment/decrement
  document.querySelectorAll('.increment').forEach(button => {
    button.addEventListener('click', () => {
      const optionId = button.dataset.option;
      const input = document.getElementById(optionId);
      const index = parseInt(optionId.split('-')[1]) - 1;
      let value = parseInt(input.value) || 0;
      value += 3; // Increment by 3
      input.value = value;
      optionQuantities[index] = value;
      updatePrice();
    });
  });

  document.querySelectorAll('.decrement').forEach(button => {
    button.addEventListener('click', () => {
      const optionId = button.dataset.option;
      const input = document.getElementById(optionId);
      const index = parseInt(optionId.split('-')[1]) - 1;
      let value = parseInt(input.value) || 0;
      value = Math.max(0, value - 3); // Decrement by 3, min 0
      input.value = value;
      optionQuantities[index] = value;
      updatePrice();
    });
  });

  // Thread color
  threadColor.addEventListener('change', () => {
    threadColorPrice = parseFloat(threadColor.selectedOptions[0].dataset.price) || 0;
    updatePrice();
  });

  // Update cart properties
  document.querySelector('form[action="/cart/add"]').addEventListener('submit', (e) => {
    if (!customOptions) return; // Exit if not on the target product
    const selectedImage = document.querySelector('input[name="image"]:checked');
    document.getElementById('cart-image').value = selectedImage ? selectedImage.nextElementSibling.querySelector('span').textContent : '';
    optionInputs.forEach((input, i) => {
      document.getElementById(`cart-option-${i + 1}`).value = input.value;
    });
    document.getElementById('cart-thread-color').value = threadColor.value ? threadColor.selectedOptions[0].text : '';
  });

  updateSteps();
  updatePrice();
});